if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
      this.pauseButton = this.parentElement.querySelector('[data-promotion-pause]');
      this.onToggle = () => {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.textContent = this.userPaused ? 'Resume scrolling' : 'Pause scrolling';
        this.userPaused ? this.scrollingPause() : this.scrollingPlay();
      };
      this.pauseButton?.addEventListener('click', this.onToggle);
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.clone.inert = true;
          this.appendChild(this.clone);
        }

        // pause when out of view
        this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        this.observer.observe(this);
      }
    }

    scrollingPlay() {
      if (this.userPaused) return;
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.pauseButton?.removeEventListener('click', this.onToggle);
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}
